import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => {
  return {
    selectedFileDescription: {
      display: 'flex',
      marginTop: '4px',
      alignItems: 'center',
      backgroundColor: '#D9E8FF',
      padding: '12px 4px',
      '& p': {
      },
    },
    buttonProgress: {
      position: 'absolute',
      top: '53px',
      right: '23px',
      background: '#fff',
      zIndex: '1',
    },
    fileUlpload: {
      alignItems: 'center',
      position: 'relative',
      '& label': {
        height: '50px !important',
        width: '100% !important',
        maxWidth: 'inherit !important',
      },
    },
    label: {
      fontSize: '13px',
      color: '#455a64',
      marginBottom: 6,
      '&.MuiInputLabel': {
        '&-shrink': {
          transform: 'translate(0, -2px) scale(1)',
        },
      },
    },
    flexColumn: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    containerFileUpload: {
      maxHeight: '400px',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      padding: '0 18px !important',
    },
    fileLink: {
      width: '100%',
      display: 'flex',
      margin: '8px 0',
      alignItems: 'center',
    },
    contentFile: {
      height: '200px !important',
      'overflow-y': 'auto',
      marginRight: '32px !important',
      marginLeft: '32px !important',
    },
    pureSelect: {
      padding: "20px 0",
      border: "1px solid #dfdfdf",
      // backgroundColor: "#F6F7F8",
      borderRadius: 8,
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          border: "1px solid #dfdfdf",
        },
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      '&.Mui-focused': {
        backgroundColor: "#fff",
        borderColor: '#2B3990 !important',
        // boxShadow: "0px 0px 0px 1px #fff, 0px 0px 0px 4px #c3dbf3 !important",
      },
    }
  };
});
